var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-button",on:{"click":function($event){$event.stopPropagation();return _vm.showPresentationReport()}}},[_c('aha-icon',{staticClass:"mr-0.5",attrs:{"name":"multiple-choice-w","width":"18","height":"18","viewBox":"0 0 30 30"}}),_c('strong',[_vm._v(_vm._s(_vm.$i18nPresenter.t('Report')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }